import React, { useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

function StockTransferMovementFilter({ onFilterChange }) {
    const [activeFilter, setActiveFilter] = useState('all');

    const handleFilterChange = (filter) => {
        setActiveFilter(filter);
        onFilterChange(filter);
    };

    return (
        <>
            <label>Filter Movement:</label>
            <ButtonGroup
                aria-label="Stock transfer movement filter"
                className="stock-log-filter m-1"
            >
                <Button
                    variant={activeFilter === 'all' ? 'primary' : 'secondary'}
                    onClick={() => handleFilterChange('all')}
                    size="sm"
                >
                    All
                </Button>
                <Button
                    variant={activeFilter === 'in' ? 'primary' : 'secondary'}
                    onClick={() => handleFilterChange('in')}
                    size="sm"
                >
                    In
                </Button>
                <Button
                    variant={activeFilter === 'out' ? 'primary' : 'secondary'}
                    onClick={() => handleFilterChange('out')}
                    size="sm"
                >
                    Out
                </Button>
            </ButtonGroup>
        </>
    );
}

export default StockTransferMovementFilter;
